var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M8.008,20.182H7.786A5.125,5.125,0,0,1,5.9,19.737a5.391,5.391,0,0,1-1.773-1.173A10.8,10.8,0,0,1,1.34,13.611a2.076,2.076,0,0,1-.613-.51A3.249,3.249,0,0,1,.02,11.172,5.371,5.371,0,0,1,.2,9.106a2.985,2.985,0,0,1,.688-1.1V6.833a7.382,7.382,0,0,1,.9-4.1A6.05,6.05,0,0,1,3.672.93,8.181,8.181,0,0,1,7.638,0H8.1A8.239,8.239,0,0,1,12.11.923a6.048,6.048,0,0,1,1.9,1.811,7.373,7.373,0,0,1,.9,4.1V8.011a2.98,2.98,0,0,1,.688,1.1,5.372,5.372,0,0,1,.183,2.066,3.352,3.352,0,0,1-.706,1.929,2,2,0,0,1-.613.51,10.8,10.8,0,0,1-2.787,4.952A5.811,5.811,0,0,1,8.008,20.182ZM1.361,9.095h0a2.9,2.9,0,0,0-.3,1.651,2.516,2.516,0,0,0,.573,1.677,1.806,1.806,0,0,0,.573.442,12.081,12.081,0,0,0,2.422,4.754A5.045,5.045,0,0,0,7.8,19.024H8a5.042,5.042,0,0,0,3.178-1.405A12.07,12.07,0,0,0,13.6,12.865a1.738,1.738,0,0,0,.573-.442,2.452,2.452,0,0,0,.573-1.677,2.879,2.879,0,0,0-.308-1.658l-.817,1.089a1.99,1.99,0,0,1-1.519.754,2.227,2.227,0,0,1-.755-.14l-.1-.038-.005,0a8.745,8.745,0,0,0-3.292-.773h-.09a8.75,8.75,0,0,0-3.3.775l-.1.038a2.221,2.221,0,0,1-.755.14,1.982,1.982,0,0,1-1.518-.754L1.361,9.1ZM7.814,7.543a16.253,16.253,0,0,0-4.185.5,7.519,7.519,0,0,0-1.412.5l.032.039c.591.741.787,1,.848,1.1a.606.606,0,0,0,.515.2,1.567,1.567,0,0,0,.326-.036A2.823,2.823,0,0,0,4.38,9.7c.18-.07.426-.166.833-.3a8.061,8.061,0,0,1,2.435-.453l.5,0a8.027,8.027,0,0,1,2.384.451c.406.134.652.229.832.3h0a2.811,2.811,0,0,0,.441.147,1.59,1.59,0,0,0,.326.036.606.606,0,0,0,.515-.2c.151-.226.873-1.126.88-1.135a7.469,7.469,0,0,0-1.412-.5,16.253,16.253,0,0,0-4.185-.5Z",
    transform: "translate(4.604 2.409)",
    fill: "#5b788f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvTraining);
export default __webpack_public_path__ + "static/media/icon_ev_training.6a301bcf4fe756871bbd40e3d8026754.svg";
export { ForwardRef as ReactComponent };